import AudioComponent from './audio.vue';

export default {
    install (_Vue) {
        const AudioConstructor = _Vue.extend(AudioComponent) 
        const instance = new AudioConstructor({
            el : document.createElement('div')
        })   
        document.body.appendChild(instance.$el)
        _Vue.prototype.$playAudio = (src) => {
            instance.playAudio(src);
        }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/audio.js